import React, {useState, useCallback, createContext, useContext} from 'react'

const defaultAPI = {
  user: {
    email: '',
  },
  updateUser: () => undefined,
}

export const UserContext = createContext(defaultAPI)
const UserContextProvider = UserContext.Provider
export const useUserContext = () => useContext(UserContext)

export const UserProvider = ({children}) => {
  const [user, setUser] = useState({...defaultAPI.user})

  const updateUser = useCallback(
    userData => {
      setUser({...user, ...userData})
    },
    [user]
  )

  return <UserContextProvider value={{user, updateUser}}>{children}</UserContextProvider>
}
